import axiosInstance from "../../translator";
import { notifcationMangement } from "../../constants/apis/apiEndpoints";

export const notificationGetApi = async (data) => {
  return axiosInstance
    .get(`${data}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationCreateApi = async (formData) => {
  return axiosInstance
    .post(`${notifcationMangement.notification}`, formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationUpdateApi = async (id, formData) => {
  return axiosInstance
    .put(`${notifcationMangement.notification}/${id}`, formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationDeleteApi = async (id) => {
  return axiosInstance
    .delete(`${notifcationMangement.notification}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationSendApi = async (data) => {
  return axiosInstance
    .post(`${notifcationMangement.send}`, data)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};
